module.exports = __webpack_public_path__ + "img/unmute_ringtone.79725de7.svg";